import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Logo from 'lib/logo';
import { HEADER } from 'config';
import { bgBlur } from 'util/cssStyles';
import AccountPopover from './AccountPopover';

const HeaderOnboarding = () => {
    const theme = useTheme();

    return (
        <AppBar
            sx={{
                ...bgBlur({
                    color: theme.palette.background.default,
                }),
                boxShadow: 'none',
                height: HEADER.H_MOBILE,
                width: '100%',
                bgcolor: 'background.default',
                borderBottom: theme => `dashed 1px ${theme.palette.divider}`,
                zIndex: theme.zIndex.appBar + 1,
                transition: theme.transitions.create(['height'], {
                    duration: theme.transitions.duration.shorter,
                })
            }}
        >
            <Toolbar
                sx={{
                    height: 1,
                    px: { lg: 5 },
                }}
            >
                <Logo
                    brandingImage
                    disabledLink
                    sx={{
                        mr: 2.5
                    }}
                />
                <Stack
                    flexGrow={1}
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-end"
                    spacing={{ xs: 0.5, sm: 1.5 }}
                >
                    <AccountPopover />
                </Stack>
            </Toolbar>
        </AppBar>
    );
};

export default HeaderOnboarding;
